import { AUTO_STYLE, animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { Category } from 'src/app/shared/services/common-api.service';
import { HeaderLayout } from '../../dynamic-header/dynamic-header.component';
import { DEFAULT_DURATION } from '../../expansion-panel/collapse/collapse.component';

@Component({
  selector: 'webstore-menu-collapse-inner',
  templateUrl: './menu-collapse-inner.component.html',
  styleUrls: ['./menu-collapse-inner.component.scss'],
  standalone: true,
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ],
  imports: [CommonModule, RouterModule]
})
export class MenuCollapseInnerComponent {

  readonly menuCollapseIcon = input<string>('');
  readonly sub_category = input<Category | null>(null);
  readonly collapsed = input<boolean>(false);
  readonly headerLayout = input<string>('default');

  // Computed collapse state mirrors parent's input
  readonly isCollapsed = computed(() => this.collapsed());

  // Computed property to check if layout is headerLayout12
  readonly isLayout12 = computed(() => this.headerLayout() === HeaderLayout.headerLayout12);

  HeaderLayout = HeaderLayout; // Exposed enum to template
  IMAGE_URLS = IMAGE_URLS;

  hideMenu$ = output<boolean>();
  selectSubCategory$ = output<string | undefined>();
}

